import type { Session } from "@supabase/supabase-js";

import { tinkrApiFetch, type ReauthPurpose } from "./client";

export interface ReauthContext {
  id: string;
  purpose: ReauthPurpose;
  method: "oauth_redirect" | "passkey" | "otp" | "password";
  verifiedAt: string;
  expiresAt: string;
}

export interface PasswordReauthResponse {
  ok: true;
  reauth: ReauthContext;
}

export async function createPasswordReauth(
  session: Session,
  input: {
    email: string;
    password: string;
    purpose: ReauthPurpose;
  }
): Promise<PasswordReauthResponse> {
  return tinkrApiFetch<PasswordReauthResponse>(session, "/auth/reauth/password", {
    method: "POST",
    body: JSON.stringify(input)
  });
}
